var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFixedPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.873 0H116.431C112.762 0 107.622 2.52894 105.03 5.60811L38.772 84.3227C37.5226 85.8139 36.8212 87.8321 36.8212 89.9364C36.8212 92.04 37.5226 94.0582 38.772 95.5495L96.1235 163.683C97.3788 165.167 99.0777 166 100.849 166C102.62 166 104.319 165.167 105.574 163.683L171.832 84.9681C174.433 81.8784 176.553 75.7835 176.553 71.424V7.936C176.548 5.83296 175.843 3.81765 174.591 2.33057C173.339 0.843495 171.643 0.0055858 169.873 0ZM136.472 63.488C134.717 63.4873 132.979 63.076 131.358 62.2774C129.736 61.4788 128.263 60.3087 127.023 58.8339C125.782 57.3591 124.798 55.6084 124.127 53.6818C123.456 51.7552 123.111 49.6904 123.112 47.6054C123.112 45.5204 123.458 43.4559 124.13 41.5298C124.803 39.6038 125.788 37.8539 127.029 36.38C128.27 34.9062 129.744 33.7372 131.366 32.94C132.988 32.1427 134.726 31.7327 136.481 31.7334C140.026 31.7348 143.425 33.4089 145.93 36.3875C148.436 39.3661 149.842 43.4051 149.841 47.616C149.84 51.827 148.431 55.8648 145.924 58.8414C143.416 61.818 140.017 63.4894 136.472 63.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8995 89.7812L88.7244 0H78.1619C74.6805 0 69.8049 2.52444 67.3459 5.59812L4.48648 84.1726C3.30121 85.6612 2.63581 87.6758 2.63581 89.7763C2.63581 91.8761 3.30121 93.8908 4.48648 95.3794L58.8959 163.391C60.0868 164.873 61.6985 165.704 63.3789 165.704C65.0588 165.704 66.6705 164.873 67.8614 163.391L71.8329 158.427L16.908 89.7707L16.8995 89.7812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFixedPrice);
export default __webpack_public_path__ + "static/media/white-fixed-price.41ed0d976e62134a5a257a632c13c002.svg";
export { ForwardRef as ReactComponent };